<div class="row page-title">
  <app-back-button [title]="localizationConstants.ADMIN_BACK_BUTTON_TITLE"></app-back-button>
  <span>{{ localizationConstants.VISIBLE_EVENTS_PAGE_TITLE | translate }}</span>
</div>

<div
  [hidden]="!params"
  class="row u-mb-3">
  <div class="col">
    <div class="o-grid">
      <div class="o-grid__item col-12 col-md-3 col-sm-5">
        <label
          class="c-form-label"
          for="role"
          >{{ "visibleevents.fam" | translate }}</label
        >
        <mat-select
          [(ngModel)]="fam"
          id="fam"
          name="fam"
          class="c-user-menu__select c-select c-select--lg"
          (ngModelChange)="onChange()"
          required>
          <mat-option
            *ngFor="let fam of params?.famcodes"
            [value]="fam">
            {{ fam }}
          </mat-option>
        </mat-select>
      </div>
      <div class="o-grid__item col-12 col-md-3 col-sm-5">
        <label
          class="c-form-label"
          for="role"
          >{{ "visibleevents.role" | translate }}</label
        >
        <mat-select
          [(ngModel)]="role"
          name="role"
          id="role"
          class="c-user-menu__select c-select c-select--lg"
          (ngModelChange)="onChange()"
          required>
          <mat-option
            *ngFor="let role of params?.roles"
            [value]="role">
            {{ role }}
          </mat-option>
        </mat-select>
      </div>
    </div>

    <div class="col">
      <div class="o-grid u-pb--medium">
        <div class="o-grid__item col-12 col-md-3 col-sm-5 u-p-bottom-only">
          <form class="c-search-form--full">
            <div class="c-input-group">
              <input
                type="text"
                name="search"
                id="input-search"
                [(ngModel)]="dataSource.filter"
                class="c-input c-input--beta"
                placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
                required />
              <input
                *ngIf="dataSource.filter"
                id="visible-events-search-clear"
                (click)="dataSource.filter = ''"
                class="c-button c-button--search c-close-search c-button--search--sm"
                value="Clear" />
              <input
                *ngIf="!dataSource.filter"
                id="visible-events-search"
                type="submit"
                class="c-button c-button--search c-button--search--sm"
                value="Search" />
            </div>
          </form>
        </div>
      </div>
      <div
        id="visible-events"
        class="col bg-white u-shadow u-scroll--horizontal">
        <div
          id="visible-events-table"
          class="tools-table col">
          <table
            mat-table
            [dataSource]="dataSource"
            matSort
            matSortActive="enabled"
            matSortDirection="desc"
            class="c-table c-table--expandable">
            <ng-container matColumnDef="eventName">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="c-table__column-title">
                {{ localizationConstants.VISIBLE_EVENTS_EVENT | translate }}
              </th>
              <td
                mat-cell
                *matCellDef="let event"
                width="70%">
                {{ event.eventName | titlecase }}
              </td>
            </ng-container>

            <ng-container matColumnDef="enabled">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="c-table__column-title">
                {{ localizationConstants.VISIBLE_EVENTS_VISIBLE | translate }}
              </th>
              <td
                mat-cell
                *matCellDef="let event"
                width="30%">
                <div>
                  <input
                    type="checkbox"
                    [name]="event.eventName + 'Slider'"
                    [id]="event.eventName + 'Slider'"
                    class="c-checkbox-slider"
                    [(ngModel)]="event.enabled"
                    (ngModelChange)="activate(event.enabled, event.eventName)" />
                  <label
                    [for]="event.eventName + 'Slider'"
                    class="c-switch-slider--left"></label>
                </div>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="['eventName', 'enabled']"></tr>
            <tr
              mat-row
              *matRowDef="let event; columns: ['eventName', 'enabled']"
              class="c-table__row"></tr>
          </table>
        </div>
      </div>
      <div class="c-pagination--desktop">
        <div class="col-12">
          <mat-paginator
            [showFirstLastButtons]="true"
            [pageSize]="pageSize"
            [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
